function Home() {

  return (<div>
    <div className="pre-title">Herzlich willkommen bei den</div>
    <div className="title">Küstenspacken</div>
    <div className="text-title">Ist es noch Musik, oder ist es schon Comedy...</div>
  </div>)
}

export default Home